import { render, staticRenderFns } from "./indica-selector.vue?vue&type=template&id=7054a59b&scoped=true&"
import script from "./indica-selector.vue?vue&type=script&lang=js&"
export * from "./indica-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7054a59b",
  null
  
)

export default component.exports